export interface ContentfulPageListing {
    slug: string;
    link_text: string;
}

export interface ContentfulPageListingGroup {
    area_used: string;
    pages?: ContentfulPageListing[];
}

let PAGE_DATA: ContentfulPageListingGroup[] | null = null;

export function seedContentfulPageData(pageData: ContentfulPageListingGroup[]): void {
    PAGE_DATA = pageData;
}

function getPageData(): ContentfulPageListingGroup[] {
    if (PAGE_DATA !== null) {
        return PAGE_DATA;
    }
    const dataTag =
        typeof document === 'undefined'
            ? null
            : document.getElementById('contentful-page-listings');
    const pageData: ContentfulPageListingGroup[] = dataTag ? JSON.parse(dataTag.innerText) : [];
    PAGE_DATA = pageData;
    return pageData;
}

interface IContentfulImageParams {
    height?: number;
    width?: number;
    format?: 'webp' | 'jpg' | 'png' | 'avif' | 'tiff' | 'gif';
    quality?: number;
}

class ContentfulTools {
    static getUrl(url: string, opts: IContentfulImageParams = {}) {
        /*
        Contenful lets you set a bunch of settings on an image at loading time:

        https://www.contentful.com/developers/docs/references/images-api/

        This function will add query params onto the url passed in, based on the opts argument:
            - height (int)
            - width (int)
        */
        const querystringDict: Record<string, number | string> = {};
        if (opts['height']) {
            querystringDict['h'] = opts['height'];
        }

        if (opts['width']) {
            querystringDict['w'] = opts['width'];
        }

        if (opts['format']) {
            querystringDict['fm'] = opts['format'];
        }

        if (opts['quality']) {
            querystringDict['q'] = opts['quality'];
        }

        const queryString = Object.keys(querystringDict)
            .map((key) => {
                return `${key}=${encodeURIComponent(querystringDict[key])}`;
            })
            .join('&');

        let finalUrl = url;
        if (!finalUrl.startsWith('http')) {
            finalUrl = `https:${url}`;
        }

        if (queryString) {
            finalUrl += `?${queryString}`;
        }
        return finalUrl;
    }

    static getPagesOfType(pageType: string) {
        const pageData = getPageData();
        let pageListings: ContentfulPageListing[] = [];
        for (let i = 0; i < pageData.length; i++) {
            if (pageData[i].area_used === pageType) {
                pageListings = pageData[i].pages || [];
            }
        }
        return pageListings.map((pageListing) => {
            return {
                url: `/${pageListing.slug}`,
                text: pageListing.link_text,
            };
        });
    }
}

export default ContentfulTools;
